import React, {useLayoutEffect, useRef, useState} from "react";
import {ProductModel} from "../../interfaces";
import Imgix from "react-imgix";
import {useAppSelector} from "../../DAL/store";
import StarRating from "../../../../ui/rating/star-rating";
import {getWindowDimensions, MOBILE_BREAKPOINT} from "../../../../domain/animations/animations-provider";
import { StopPropagation } from "../../services/logic-helper";

interface IPluginViewSortOptionsProps {
    product : ProductModel;
}

export const PluginViewLg = (props : IPluginViewSortOptionsProps) => {

    const ImgCdnDomain = useAppSelector((store) => store.ImgCdnDomain);
    const containerRef = useRef(null);
    const [isFlipView, setIsFlipView] = useState(false);
    const [viewHeight, setViewHeight] = useState(0);
    const PluginViewPosition = useAppSelector((store) => store.PluginViewPosition);
    const windowWidth = getWindowDimensions().width;

    const getContainerStyle = () : any =>  {
        let containerStyle = {};
        if(windowWidth !== undefined && windowWidth <= MOBILE_BREAKPOINT){
            containerStyle = {zIndex:111,width:"100vw",height:"100vh",top:"0px",left:"0px"};
        }else{
            if(isFlipView){
                containerStyle = {zIndex:111,left:(PluginViewPosition.left + 37) + "px",top: (PluginViewPosition.top - viewHeight + 47 ) + "px"};
            }else{
                containerStyle ={zIndex:111,left:(PluginViewPosition.left + 37) + "px",top: PluginViewPosition.top - 16 + "px"};
            }
        }

        return containerStyle;
    }
    /**
     * Performs the layout measurements before the browser repaints the screen
     * Inorder to position the plugin view popup ( after eyeIcon click) we need to know what is the height of the element that PluginView renders
     *
     * isFlipView === True --> the popup element overflows --> flip the speech bubble up
     *
     * isFlipView === False --> the popup element doesn't overflow --> flip the speech bubble down
     */
    useLayoutEffect(() => {

        const pluginsContainerElement = document.getElementById('plugins-list-container');

        if(containerRef.current === null || pluginsContainerElement === null || windowWidth <= MOBILE_BREAKPOINT){
            return;
        }
        // @ts-ignore
        const { height } = containerRef.current.getBoundingClientRect();
        const pluginsContainerPos = pluginsContainerElement.getBoundingClientRect();

        const relativeTopToPluginsContainer   = PluginViewPosition.top - pluginsContainerPos.top;
        setViewHeight(height);

        if((relativeTopToPluginsContainer + height) > pluginsContainerElement.offsetHeight){
            setIsFlipView(true);
        }else{
            setIsFlipView(false);
        }

    }, [PluginViewPosition,windowWidth]);
    return (
        <div className="fixed" key={props.product.sortIncludes} style={getContainerStyle()}  onClick={StopPropagation}>
            <div className={`plugin-white-popup ${ isFlipView ? "plugin-white-popup-flip" : ""}`}>
                <div className={`plugin-view-container`}  ref={containerRef}>
                    <div className="plugin-image-container flex items-center justify-center">
                        <Imgix
                            className="plugin-view-image"
                            src={ ImgCdnDomain + props.product.thumb }
                            width={170}
                            htmlAttributes={{
                                alt: `Image for ${ props.product.documentName }`,
                                loading: 'lazy',
                            }}
                        />
                    </div>
                    <div className="p-6 bg-white">
                        <div className="font-bold">{props.product.documentName}</div>
                        <div className="pt-2">{props.product.documentPageDescription}</div>
                        <StarRating
                            // @ts-ignore
                            rating={ props.product.rating }
                            // @ts-ignore
                            reviews={ props.product.reviewsTotal }
                            url={ props.product.documentUrlPath }
                            className="pt-2"
                            gaEventName={ 'Click Reviews' }
                            gaEventValue={ props.product.documentName }
                        />
                    </div>

                </div>
            </div>
        </div>
    )
};